import React, { useState } from 'react';
import 'stylesheets/fonts.scss';
import 'stylesheets/colors.scss';
import 'stylesheets/layout.scss';
import 'stylesheets/ConfirmModal.scss';
import './AddRoleModal.scss';
import text from 'strings/text';
import { injectIntl } from 'react-intl';
import ColorPicker from './ColorPicker';

export function AddRoleModal({ addRole, closeModal, title, explain, roles = [] }) {
    const [selectedColor, setSelectedColor] = useState('0A84FF');
    const [roleName, setRoleName] = useState('');

    const handleCancel = (event) => {
        closeModal();
    }
    
    const handleConfirm = (event) => {
        if( isConfirmEnabled && roleName && selectedColor) {
            addRole(roleName, selectedColor);
            closeModal();
        }
    }

    const handleColorSelect = (color) => {
        setSelectedColor(color);
    };

    const handleRoleNameChange = (event) => {
        setRoleName(event.target.value);
    };

    const isRoleNameValid = () => {
        const trimmedRoleName = roleName.trim();
        return trimmedRoleName.length > 0;
    };

    const isRoleNameConflict = () => {
        const trimmedRoleName = roleName.trim();
        return roles.some(role => role.name.toLowerCase() === trimmedRoleName.toLowerCase());
    };

    const isConfirmEnabled = selectedColor && isRoleNameValid() && !isRoleNameConflict();

    return (
        <div className="confirm-modal-container">
            <label className="title-text">{title}</label>
            <div className='body-text1 fs14'>{explain}</div>

            <div className='flex-row'>
                <div className='role-name-col flex-col'>
                    <label className='semibold-12'>{text.roleName}</label>
                    <input 
                        className="role-input" 
                        type="text" 
                        value={roleName} 
                        onChange={handleRoleNameChange}
                        placeholder=""
                    />
                    {roleName && !isRoleNameValid() && (
                        <div className="error-msg">{text.roleNameEmptyError}</div>
                    )}
                    {roleName && isRoleNameValid() && isRoleNameConflict() && (
                        <div className="error-msg">{text.roleNameConflictError}</div>
                    )}
                </div>

                <div className='role-color-col flex-col'> 
                    <label className='semibold-12'>{text.color}</label>
                    <ColorPicker 
                        selectedColor={selectedColor}
                        onColorSelect={handleColorSelect}
                    />
                </div>
            </div>

            <div className="confirm-button-wrap">
                <button className="confirm-button-cancel" onClick={handleCancel}>{text.cancel}</button>
                <button className={`confirm-button ${isConfirmEnabled ? 'button-enabled' : 'button-disabled'}`} onClick={handleConfirm}>{text.confirm}</button>
            </div>
        </div>
    )
}

export default injectIntl(AddRoleModal);